import type { ValueOf } from '@weft/utils';

export const ACTIONS_METHODS = Object.freeze({
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
  PATCH: 'patch',
  HEAD: 'head',
  OPTIONS: 'options',
});

export const ACTION_METHOD_VALUES = Object.values(ACTIONS_METHODS);

export type ActionMethod = ValueOf<typeof ACTIONS_METHODS>;